
import React from 'react';
// functions


function BodyTextPart({ text }) {

  return (
    <div className="delivery__details custom-note">
      <p>
        
        <RenderBodyText text={ text } /></p>


      </div>
  );
}


function RenderBodyText({ text }) {
  return (
    <div>{ text }</div>
  );
}

export default BodyTextPart;


// WEBPACK FOOTER //
// ./src/cards/templates/DetailsConfirmCard/BodyTextPart.js